import Box from '@risk-smart/themed-cloudscape-components/box';
import ErrorContent from '@risksmart-app/components/src/error-pages/ErrorContent';
import type { FC, ReactNode } from 'react';
import Loading from 'src/components/loading';

import { useGetRoleAccess } from '@/hooks/queries/role-access/useGetRoleAccess';

import { PermissionsContext } from './PermissionsContext';

type Props = { children: ReactNode };

export const PermissionsProvider: FC<Props> = ({ children }) => {
  // Under V3 the bridge skips the getRoleAccess read and returns an empty
  // (non-null) catalog — permission decisions come from the perm_v2 batch
  // endpoints, not role_access. The legacy (trpc-off) path fetches as before.
  const { roleAccess, loading, error } = useGetRoleAccess();

  return (
    <PermissionsContext.Provider value={roleAccess ?? null}>
      {loading && <Loading data-loading-reason={'permissions'} />}
      {error && (
        <ErrorContent
          title={'Sorry, we couldn’t make that happen'}
          imgSrc={'/errors/rubiks-cube.png'}
          imgAlt={'binoculars'}
        >
          <Box variant={'p'}>{'Please try again later'}</Box>
        </ErrorContent>
      )}
      {!error && !loading && children}
    </PermissionsContext.Provider>
  );
};
